import React from "react";
import style from "./style.module.scss";
import { Table, Button, Container, Row, Col, Input, InputGroup, InputGroupAddon } from "reactstrap";
import { useState } from "react";
import { useEffect } from "react";
import { SearchBox } from "../../../SearchBox/SearchBox";
import NewCreditRangeModal from "../Modals/NewCreditRangeModal";
import { Mode } from "../../types";

const CreditRatingToolbar = ({
  onFilter,
  count,
  services,
  modals,
  handleAction,
  toggleModal,
  agencies,
  getRatingsByRiskRangeId,
  removeRatingFromRange,
  lastOrder,
}) => {
  const [filter, setFilter] = useState("");

  useEffect(() => {
    onFilter(filter);
  }, [filter]);

  return (
    <div>
      <div className={style.toolbar}>
        <Row>
          <Col md={0} lg={2}>
            <h6 className={"h6 page-title " + style.totals}>Credit Rating Manange</h6>
            <div className="text-muted page-desc">Count: {count} </div>
          </Col>
          <Col md={5} lg={4}>
            <div>
              <SearchBox changeValue={({ text }) => setFilter(text)} text={filter} />
            </div>
          </Col>
          <Col lg={2}></Col>

          <Col lg={4} className={style.export}>
            <Button color="primary" onClick={() => handleAction(Mode.Insert)}>
              <i className="fa fa fa-bolt"></i>
              {"\u00A0"} New Risk Range
            </Button>
          </Col>
        </Row>
      </div>

      {modals.newRiskRange.open && (
        <NewCreditRangeModal
          modal={modals.newRiskRange}
          open={modals.newRiskRange.open}
          toggleModal={() => toggleModal("newRiskRange")}
          agencies={agencies}
          getRatingsByRiskRangeId={getRatingsByRiskRangeId}
          services={services}
          removeRatingFromRange={removeRatingFromRange}
          lastOrder={lastOrder}
        />
      )}
    </div>
  );
};

export default CreditRatingToolbar;
